module.exports = __webpack_public_path__ + "img/lecturers-image.e29f32e8.jpg";